import { useEffect, useRef, useState } from "react";
import {
  GameClubAllList3Rank,
  GameClubAllListItemLeft,
  GameClubAllListItemRight,
  GameClubAllListRank,
  GameClubAllListWrapper,
  GameClubListItem,
  GameClubListWrapper,
} from "../Style/GameClubAllStyles";
import { useGameClubContext } from "../Hook/GameClubContext";
import {
  cancelJoinRequest,
  GameClubDto,
  getClubList,
} from "../../../../api/game-club";
import { LOCAL_STORAGE_ACCESS_KEY } from "../../../../utils/network";
import { useHistory } from "react-router-dom";
export interface GameClubAllListProps {
  search: string;
}
export const GameClubAllList = ({ search }: GameClubAllListProps) => {
  const {
    setIsClubJoin,
    clubId,
    setPopupType,
    setSelectClubId,
    setGetData,
    myClub,
    myJoinRequest,
    setMyJoinRequest,
  } = useGameClubContext();

  const history = useHistory();
  const [list, setList] = useState<GameClubDto[]>([]);
  const listRef = useRef<HTMLDivElement | null>(null);

  const getList = async () => {
    try {
      const token = localStorage.getItem(LOCAL_STORAGE_ACCESS_KEY);
      const accessToken = token ? token.replace("Bearer ", "") : "-";
      if (!accessToken) {
        history.push("/login");
        return;
      }
      const res = await getClubList(1, 999, search, accessToken);
      setList(res.payload.clubs);
    } catch (e) {
      setList([]);
      console.log(e);
    }
  };

  useEffect(() => {
    getList();
  }, [search, clubId]);

  const handleJoin = (id: number) => {
    setSelectClubId(+id);
    setIsClubJoin(true);
    if (id === -1) {
      setPopupType("opened");
    }
    setGetData(() => async () => {
      getList();
    });
  };

  const handleCancelRequest = async (id: number) => {
    const token = localStorage.getItem(LOCAL_STORAGE_ACCESS_KEY);
    const accessToken = token ? token.replace("Bearer ", "") : "-";
    try {
      await cancelJoinRequest(id, accessToken);
      setMyJoinRequest(null);
    } catch (e) {
      console.log(e);
    }
  };

  const handleButtonClick = (item: GameClubDto) => {
    if (myClub !== null) {
      handleJoin(item.clubId);
      setPopupType("read");
    } else {
      if (!myJoinRequest) {
        handleJoin(item.clubId);
        setPopupType("join");
      } else {
        if (myJoinRequest.clubId === item.clubId) {
          if (!myJoinRequest.requestId) return;
          handleCancelRequest(myJoinRequest.requestId);
        } else {
          handleJoin(item.clubId);
          setPopupType("read");
        }
      }
    }
  };

  const getButtonText = (item: GameClubDto) => {
    if (myClub !== null) return "정보";
    if (myJoinRequest) {
      return myJoinRequest.clubId === item.clubId ? "신청 취소" : "정보";
    }
    return "가입";
  };

  return (
    <>
      <GameClubAllListWrapper ref={listRef}>
        <GameClubListWrapper>
          {list.length !== 0 ? (
            list.map((item, index) => (
              <GameClubListItem key={index}>
                <GameClubAllListItemLeft>
                  <div className="profile">
                    <img
                      src={`/image-web/game/club/profile_${item.profileType}.png`}
                      alt="프로필"
                    />
                  </div>
                  <div className="name">{item.name}</div>
                </GameClubAllListItemLeft>
                <GameClubAllListItemRight>
                  <div className="member">
                    {item.memberCount.toLocaleString()}명
                    <div className="update">
                      ({item.thisMonthJoinCount.toLocaleString()}
                      <img
                        src="/image-web/game/club/member-update.svg"
                        alt="업데이트"
                      />
                      )
                    </div>
                  </div>
                  <div
                    className="button"
                    onClick={() => {
                      handleButtonClick(item);
                    }}
                  >
                    {getButtonText(item)}
                  </div>
                </GameClubAllListItemRight>
              </GameClubListItem>
            ))
          ) : (
            <div className="no-data">
              클럽이 존재하지 않습니다. 첫 클럽을 만들어보세요!!
            </div>
          )}
        </GameClubListWrapper>
      </GameClubAllListWrapper>
    </>
  );
};
